<template>
  <div class="timeline">
    <div class="wrap">
      <h2>{{title}}</h2>
      <ul class="main">
        <li class="item" v-for="item in list">
            <div class="content">
              <div class="circle"><span><i :class="'fa fa-'+item.icon"></i></span></div>
              <div class="title">{{item.title}}</div>
              <ul class="desc">
                <li v-for="d in item.desc">{{d}}</li>
              </ul>
              <div class="icon"><span></span></div>
            </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props:['title','list']
  }
</script>

<style lang="sass">
@import 'assets/style/variable.sass'
$circle: 120px
.timeline
  padding: 0 15px
  h2
    text-align: center
    font-size: 2em
    font-weight: bold
    margin: 1em auto
  .main 
    position: relative
    margin: auto
    &:before, &:after
      content: ""
      display: block
      width: 100%
      clear: both
    &:before
      content: ""
      width: 3px
      height: 100%
      background: #302124
      position: absolute
      top: 0
    .item
      position: relative
      z-index: 1
      &:before, &:after
        content: ""
        display: block
        width: 100%
        clear: both
      &:first-child:before, &:last-child:before
        content: ""
        width: 25px
        height: 25px
        border-radius: 50%
        background: #fff
        border: 4px solid $theme
        position: absolute
        top: 0
        z-index: 1
      &:last-child:before
        top: auto
        bottom: 0
      &:last-child:nth-child(even):before
        right: auto
        left: -12px
        bottom: -2px
      .title
        font-size: 1.8em
        font-weight: bold
        margin-top: $circle/2 - 60px
        margin-bottom: 40px
        padding: 3px 7px
        border-radius: 6px
        background: $theme
        color: #fff
        display: inline-block
      .content
        width: 100%
        text-align: center
        margin-top: 8px
        position: relative
        transition: all 0.3s ease 0s
        &:before
          content: ""
          width: 100%
          height: 5px
          background: $theme
          position: absolute
          top: $circle/2-2px
          left: 0
          z-index: -1
        .circle
          width: $circle
          height: $circle
          border-radius: 50%
          background: #fff
          border: 8px solid $theme
          float: left
          margin-right: 25px
          position: relative
          &:before
            content: ""
            width: 26px
            height: 30px
            background: $theme
            margin: auto
            position: absolute
            top: 0
            right: -32px
            bottom: 0
            z-index: -1
            box-shadow: inset 7px 0 9px -7px #444
          span
            display: block
            width: 100%
            height: 100%
            border-radius: 50%
            line-height: $circle - 20px
            border: 3px solid #adabab
            font-size: $circle/2
            color: #454344
            &:before, &:after
              content: ""
              width: 28px
              height: 50px
              background: #fff
              border-radius: 0 0 0 21px
              margin: auto
              position: absolute
              top: -54px
              right: -33px
              bottom: 0
              z-index: -1
            &:after
              border-radius: 21px 0 0 0
              top: 0
              bottom: -56px
        .desc
          text-align: left
        .icon
          width: 25px
          height: 25px
          border-radius: 50%
          background: #fff
          border: 4px solid $theme
          position: absolute
          top: $circle/2-12px
          right: -14px
          &:before
            content: ""
            width: 15px
            height: 25px
            background: $theme
            margin: auto
            position: absolute
            top: -1px
            left: -15px
            bottom: 0
            z-index: -1
          & span:before, & span:after
            content: ""
            width: 21px
            height: 25px
            background: #fff
            border-radius: 0 0 21px 0
            margin: auto
            position: absolute
            top: -30px
            left: -15px
            bottom: 0
            z-index: -1
          & span:after
            border-radius: 0 21px 0 0
            top: 0
            left: -15px
            bottom: -30px
      &:nth-child(2)
        margin-top: $circle*0.8
      &:nth-child(odd)
        margin-top: 0-$circle*0.8
      &:nth-child(even)
        margin-bottom: $circle
      &:first-child, &:last-child:nth-child(even)
        margin: 0

@media screen and (min-width: 991px)
  .timeline
    .main
      max-width: $safe-width
      &:before
        left: 50%
      .item
        width: 50%
        float: left
        &:first-child:before, &:last-child:before
          right: -14px
        &:nth-child(odd)
          .desc
            padding-left: $circle+25px
            padding-right: 40px
        &:nth-child(even)
          left: 3px
          .content, .circle
            float: right
          .circle
            margin: 0 0 0 25px
            &:before
              right: auto
              left: -32px
              box-shadow: -7px 0 9px -7px #444 inset
            span:before, span:after
              right: auto
              left: -32px
              border-radius: 0 0 21px 0
            span:after
              border-radius: 0 21px 0 0
          .content
            padding: 0 0 0 40px
            margin-left: 2px
            .desc
              padding-right: $circle+25px
          .icon
            right: auto
            left: -14px
            &:before, span:before, span:after
              left: auto
              right: -15px
            span:before
              border-radius: 0 0 0 21px
            span:after
              border-radius: 21px 0 0 0

@media screen and (max-width: 990px) 
  .timeline
    .main
      max-width: 750px
      &:before
        left: 100%
      .item
        float: none
        width: 100%
        margin-bottom: 20px !important
        &:first-child:before, &:last-child:before
          left: auto !important
          right: -13px !important
        &:nth-child(2n) 
          .circle
            float: left
            margin: 0 25px 0 0
          &:before
            right: -33px
            left: auto
            box-shadow: 7px 0 9px -7px #444 inset
          span:before, span:after
            right: -33px
            left: auto
            border-radius: 0 0 0 21px
          span:after
            border-radius: 21px 0 0 0
          .content
            padding: 0 40px 0 0
            margin-left: 0
          .icon
            right: -14px
            left: auto
            &:before, span:before, span:after
              left: -15px
              right: auto
            span:before
              border-radius: 0 0 21px 0
            span:after
              border-radius: 0 21px 0 0
      .item:nth-child(2), .item:nth-child(odd), .item:nth-child(even)
        margin: 0

@media screen and (max-width: 480px)
  $circle: 100px
  .timeline
    .main
      text-align: center
      &:before
        left: 0
      .item
        &:first-child:before, &:last-child:before
          left: -12px !important
          right: auto !important
        .title
          margin-top: 20px
        .content .circle
          width: $circle !important
          height: $circle !important
          float: none !important
          margin: 0 auto !important
          span
            line-height: 115px
            font-size: 60px
        .circle:before, .circle span:before, .circle span:after, .icon
          display: none !important
      .content:before
        width: 99.5% !important
        top: 68px !important
        left: 0.5% !important
      .content
        padding: 0 10px !important
</style>


// WEBPACK FOOTER //
// src/components/Timeline.vue